"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPalette = void 0;
var theme_1 = require("@fluentui/theme");
Object.defineProperty(exports, "DefaultPalette", { enumerable: true, get: function () { return theme_1.DefaultPalette; } });
//# sourceMappingURL=DefaultPalette.js.map